import React, { Component } from 'react';
import Button from '../Buttons'
import { DIST_URL } from '../../constants/api';

export default class MoreButton extends Component {

  render(){

  	const { onClickMore } = this.props;
  	
    return (
      <Button classes="btn-plus" clickButton={onClickMore}>
        <img src={DIST_URL+'/assets/images/plus.png'} alt="More" />
      </Button>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Buttons/plus.js